import type {
  GetNutritionLabelRequest,
  GetNutritionLabelResponse,
} from '@/lib/TypesOpenApi';
import {getOpenApiNutritionLabelBaseUrl} from '@/lib/open-api';
import {isRequestMockingEnabled, type paths} from '@gfiber/pixel-party';
import {fetchPost} from './fetchPost';

export const fetchNutritionLabels = async (
  globalAddrId: string,
  request: GetNutritionLabelRequest,
): Promise<GetNutritionLabelResponse> => {
  if (isRequestMockingEnabled()) {
    return fetchLocalMock(globalAddrId, request);
  }

  const {data} = await fetchPost<paths>({
    baseUrl: getOpenApiNutritionLabelBaseUrl() || 'openapi',
    path: '/v1/nutritionLabel',
    globalAddrId,
    body: request as any,
  });

  return data;
};

async function fetchLocalMock(
  globalAddrId: string,
  request: GetNutritionLabelRequest,
): Promise<GetNutritionLabelResponse> {
  // Log to allow investigate body during development
  console.log('Nutrition label request body', globalAddrId, request);
  const response = await fetch('http://localhost:3000/nutritionlabels');
  const data = await response.json();

  return data;
}
